export default {"src":"/_next/static/media/toggle-settings-to-set-pay-mode-en.4cbfee26.gif","height":250,"width":600,"blurWidth":0,"blurHeight":0};